import { Alert, useTheme } from "@mui/material";
import React from "react";

function LastRefreshed({ date }) {
    const theme = useTheme();

    // Parse the date and format it manually
    const parseDate = new Date(date);
    const day = String(parseDate.getDate()).padStart(2, "0");
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];
    const month = monthNames[parseDate.getMonth()];
    const year = String(parseDate.getFullYear()).slice(-2);
    const hours = parseDate.getHours();
    const minutes = String(parseDate.getMinutes()).padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

    const formattedDate = `${day} ${month} '${year} at ${formattedHours}:${minutes} ${period}`;

    return (
        <Alert
            severity="info"
            sx={{
                marginTop: "20px",
                backgroundColor: theme.palette.primary[50],
            }}
        >
            The data shown above was last refreshed on {formattedDate}
        </Alert>
    );
}

export default LastRefreshed;
